import defaultTheme from '@kiwicom/orbit-components/lib/defaultTheme';

/** Loader's height for title in PageHeader. */
export const PAGE_HEADER_TITLE_HEIGHT = defaultTheme.orbit.headingTitle2LineHeight;

/** Loader's height for description in PageHeader. */
export const PAGE_HEADER_DESCRIPTION_HEIGHT = defaultTheme.orbit.lineHeightLarge;
